import { ArticleCard } from '@/components/organisms/ArticleCard';
import { BlogPreview } from '@/types/blog';

interface RelatedNewsProps {
  posts: BlogPreview[];
  title?: string;
}

/**
 * Server-rendered "Related news": articles sharing this article's tags first,
 * then the latest in the same category (chosen in app/news/[slug]/page.tsx).
 * Uses the same ArticleCard as the /news "Latest news" grid. On phones it is a
 * swipeable row of compact cards (like the "More" row); from md up it's a grid.
 */
export const RelatedNews = ({
  posts,
  title = 'Related news',
}: RelatedNewsProps) => {
  if (!posts.length) return null;

  return (
    <section
      aria-labelledby="related-news-heading"
      className="flex flex-col gap-l"
    >
      <h2 id="related-news-heading" className="text-h3SemiBold">
        {title}
      </h2>
      <div className="-mx-l flex snap-x snap-mandatory gap-m overflow-x-auto scroll-px-l px-l pb-s md:mx-0 md:grid md:snap-none md:grid-cols-2 md:gap-l md:overflow-visible md:px-0 md:pb-0 l:grid-cols-4">
        {posts.map((post) => (
          <div
            key={post.id}
            className="flex w-[78%] max-w-[320px] shrink-0 snap-start md:w-auto md:max-w-none"
          >
            <ArticleCard article={post} size="small" />
          </div>
        ))}
      </div>
    </section>
  );
};
